import styled from "styled-components"
import {error} from "@irati/ui/src/global/colors"

export default styled.span`
  color: ${error};
  font-size: 10px;
  position: relative;
`
